__turbopack_context__.v({
  "banner": "SmartAppBanner-module-scss-module__6k1Oxq__banner",
  "copy": "SmartAppBanner-module-scss-module__6k1Oxq__copy",
  "cta": "SmartAppBanner-module-scss-module__6k1Oxq__cta",
  "dismiss": "SmartAppBanner-module-scss-module__6k1Oxq__dismiss",
  "icon": "SmartAppBanner-module-scss-module__6k1Oxq__icon",
  "tagline": "SmartAppBanner-module-scss-module__6k1Oxq__tagline",
  "title": "SmartAppBanner-module-scss-module__6k1Oxq__title",
});
